import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 30 * 60 * 1000,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  // 캐시 구조 변경 시 blue/green 토글하여 기존 사용자 localStorage 캐시 무효화
  // 2026-10-03: classroom 쿼리 키 rename (classroom-expression→classroom-expression 등)으로 토글
  buster: 'cache-green',
});

// 앱 초기 로드 시 persist 캐시를 stale 처리하여 첫 마운트에서 refetch
queryClient.invalidateQueries();
